export function host(url) {
  const host  = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
  const parts = host.split('.').slice(-3)
  if (parts[0] === 'www') parts.shift()
  return parts.join('.')
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return ~~(between / 60) + pluralize(~~(between / 60), ' minute')
  }
  else if (between < 86400) {
    return ~~(between / 3600) + pluralize(~~(between / 3600), ' hour')
  }
  else {
    return ~~(between / 86400) + pluralize(~~(between / 86400), ' day')
  }
}

export function pluralize(time, label) {
  if (time === 1) {
    return label
  }
  return label + 's'
}

export function limit(text, limit) {
  if (text.length <= limit) {
    return text;
  }
  else {
    return text.slice(0, limit) + '...';
  }
}

export function pluckAddressNumber(address) {
  let match = address.match(/^\d+|\d+\b|\d+(?=\w)/);
  return match !== null
    ? match[0]
    : '';
}

// format a percentage: 15.15 -> 15.15%
export function percent(val) {
  if (val === undefined || val === null || val === '') {
    return '';
  }
  val = val.toString().trim();
  return (val !== '') ? val + '%' : '';
}

export function phone(val) {
  if (val === undefined || val === null || val === '') {
    return '';
  }
  val = val.toString().trim().replace(/([^\d]+)/g, '');
  return '(' + val.substr(0, 3) + ') ' + val.substr(3, 3) + "-" + val.substr(6, 4);
}

export function replace(val, search, replace) {
  return val.replace(search, replace);
}

export function currency(value, decimals = 2, currency = '$') {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency        = currency != null ? currency : '$'
  let stringified = Math.abs(value).toFixed(decimals)
  let _int        = stringified.slice(0, -1 - decimals)
  let i           = _int.length % 3
  let head        = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  let _float      = stringified.slice(-1 - decimals)
  let sign        = value < 0 ? '-' : ''
  return sign + currency + head +
         _int.slice(i).replace(/d+/, '$1,') +
         _float
}

export function prettyBytes(num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  num = Number(num);
  if (isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  let neg   = num < 0;
  let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  let exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num          = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  let unit     = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/filters/index.js
// module id = 232
// module chunks = 0